/* eslint-disable */
import React, { useRef, useState } from 'react';
import { Star } from 'lucide-react';

// Interactive star picker with 0.1 precision via pointer position.
// Also includes a fallback numeric slider for accessibility / mobile.
const SIZE = 36;

const StarPicker = ({ value, onChange }) => {
  const ref = useRef(null);
  const [hover, setHover] = useState(null);
  const display = hover !== null ? hover : value;

  const calcFromPointer = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.max(0, Math.min(1, x / rect.width));
    // 0.1 increments, min 0.1, max 5.0
    return Math.max(0.1, Math.min(5, Math.round(pct * 50) / 10));
  };

  const handlePointerMove = (e) => {
    if (!ref.current) return;
    setHover(calcFromPointer(e.clientX));
  };
  const handlePointerLeave = () => setHover(null);
  const handlePointerDown = (e) => {
    if (!ref.current) return;
    onChange(calcFromPointer(e.clientX));
  };

  return (
    <div>
      <div className="flex items-center gap-4">
        <div
          ref={ref}
          role="slider"
          aria-label="Star rating"
          aria-valuemin={0.1}
          aria-valuemax={5}
          aria-valuenow={value}
          tabIndex={0}
          onPointerMove={handlePointerMove}
          onPointerLeave={handlePointerLeave}
          onPointerDown={handlePointerDown}
          className="inline-flex items-center gap-1 cursor-pointer select-none touch-none"
        >
          {[0, 1, 2, 3, 4].map((i) => {
            const fill = Math.max(0, Math.min(1, display - i));
            return (
              <span key={i} className="relative inline-block" style={{ width: SIZE, height: SIZE }}>
                <Star width={SIZE} height={SIZE} strokeWidth={1.2} style={{ color: '#cdc2b1' }} className="absolute inset-0" />
                <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
                  <Star width={SIZE} height={SIZE} strokeWidth={1.2} fill="#1a1410" style={{ color: '#1a1410' }} />
                </span>
              </span>
            );
          })}
        </div>
        <div className="font-serif text-2xl text-[#1a1410] w-20">{display.toFixed(1)} / 5</div>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <span className="text-[10px] tracking-[0.22em] text-[#7a6a5a]">FINE-TUNE</span>
        <input
          type="range"
          min="1"
          max="50"
          step="1"
          value={Math.round(value * 10)}
          onChange={(e) => onChange(parseInt(e.target.value, 10) / 10)}
          className="flex-1 accent-[#1a1410]"
          aria-label="Rating slider"
        />
      </div>
    </div>
  );
};

export default StarPicker;
